var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncumbent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jk90bage2a)",
    fill: "#706F6F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.892 7.727h5.04c-.055.61-.097 1.18-.157 1.75-.106 1.008-.24 2.01-.333 3.018-.042.442-.217.682-.645.682h-2.75c-.395 0-.595-.217-.64-.624C1.24 10.97 1.07 9.385.895 7.727H.892zM3.47 5.092c.895 0 1.79.008 2.686 0 .484-.005.687.227.71.739.063 1.582.041 1.616-1.478 1.616-1.505 0-3.009.003-4.516 0-.77-.002-.867-.114-.872-.94-.005-.942.44-1.413 1.334-1.413h2.134l.003-.002zM2.767 3.047c.262.373.447.637.632.898.198-.266.398-.532.662-.888 1.236-.115 1.866.47 1.628 1.732H1.174c-.225-1.3.177-1.7 1.593-1.745v.003zM3.394.177c.68-.016 1.203.525 1.208 1.246.005.697-.474 1.238-1.124 1.264-.667.028-1.228-.512-1.252-1.21-.022-.691.509-1.284 1.168-1.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jk90bage2a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .177)",
    d: "M0 0h6.882v13H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncumbent);
export default __webpack_public_path__ + "static/media/icon-incumbent.205cd1503b2206a7695191851822c6f8.svg";
export { ForwardRef as ReactComponent };